import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const AccordionStyle = styled.div`
  margin-bottom: 1rem;

  /* Parent styles
  ------------------------------- */

  .MuiPaper-root {
    box-shadow: none;
  }

  .MuiButtonBase-root {
    align-items: flex-start;
    user-select: auto;
  }

  .MuiAccordionSummary-root {
    padding: 0;
  }

  .MuiAccordionSummary-content {
    margin: 0;

    &.Mui-expanded {
      margin: 0;
    }
  }

  .MuiButtonBase-root {
    position: relative;
  }

  .MuiIconButton-root {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }

  .MuiAccordionDetails-root {
    padding: 0;
  }

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
